import React, { useEffect, useRef, useState } from "react";
import { Card } from "react-bootstrap";

import ExpertPicker from "./ExpertPicker";

function AddExpertInput({ existingExpertsIds, onSubmit, onCancel }) {
  const [expertId, setExpertId] = useState(null);

  const selectRef = useRef();

  const expertAdditionConfirmed = () => {
    if (expertId !== null) {
      onSubmit(expertId);
    }
  };

  const expertPickerKeyDown = (e) => {
    if (e.key === "Enter" && selectRef.current.state.inputIsHidden) {
      if (expertId !== null) {
        onSubmit(expertId);
      }
    } else if (e.key === "Escape") {
      onCancel();
    }
  };

  useEffect(() => {
    if (selectRef.current) {
      selectRef.current.focus();
    }
  }, []);

  return (
    <div className="col col-12">
      <Card className="p-2 d-flex flex-row h-100 align-items-center">
        <ExpertPicker
          onExpertPicked={setExpertId}
          onKeyDown={expertPickerKeyDown}
          expertsIdsToExclude={existingExpertsIds}
          selectRef={selectRef}
        />
        <button type="button" className="btn btn-primary" onClick={expertAdditionConfirmed}>
          Add
        </button>
      </Card>
    </div>
  );
}

export default AddExpertInput;
